<h2 mat-dialog-title class="fw-bold fs-18 mb-2 dialog-title">
  Generate New Master Batch
</h2>
<mat-dialog-content class="pb-2">
  <p class="text-muted fs-13 mb-3">
    Each code in the batch will have a sequential barcode with random security tokens and a unique 16-hex QR code.
  </p>
  <form [formGroup]="batchForm">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Start Sequence Number</mat-label>
          <input matInput type="number" formControlName="startSeq" placeholder="e.g. 1" min="1" />
          <mat-error *ngIf="batchForm.get('startSeq')?.hasError('required')">
            Start sequence is required
          </mat-error>
          <mat-error *ngIf="batchForm.get('startSeq')?.hasError('min')">
            Start sequence must be at least 1
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>End Sequence Number</mat-label>
          <input matInput type="number" formControlName="endSeq" placeholder="e.g. 100" min="1" />
          <mat-error *ngIf="batchForm.get('endSeq')?.hasError('required')">
            End sequence is required
          </mat-error>
          <mat-error *ngIf="batchForm.get('endSeq')?.hasError('min')">
            End sequence must be at least 1
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="summary-box d-flex align-items-center justify-content-between mb-3">
      <span><strong class="text-dark">Total Codes:</strong> {{ calculatedTotal }}</span>
      <span class="info-tag">Dynamic Padding</span>
    </div>

    <!-- Live progress indicator while generating in background -->
    <div *ngIf="isPolling" class="p-3 mb-3 bg-light rounded border">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <span class="fs-13 fw-semibold text-primary">
          <mat-icon class="align-middle me-1" style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle;">autorenew</mat-icon>
          Generating codes in background...
        </span>
        <span class="fs-13 fw-bold text-primary">{{ generationProgress }}%</span>
      </div>
      <div class="progress" style="height: 6px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar" [style.width.%]="generationProgress"></div>
      </div>
      <div class="text-muted fs-11 mt-1">Safe to close dialog; generation continues on server.</div>
    </div>

    <div *ngIf="batchForm.errors?.['invalidRange'] && batchForm.touched" class="text-danger fs-12 mb-2">
      End sequence number must be greater than or equal to Start sequence number.
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="pt-2">
  <button mat-button (click)="onCancel()">{{ isPolling ? 'Close (Runs in Background)' : 'Cancel' }}</button>
  <button mat-raised-button color="primary" (click)="onGenerate()" [disabled]="batchForm.invalid || isSubmitting || calculatedTotal <= 0">
    <span *ngIf="!isSubmitting">Generate Batch</span>
    <span *ngIf="isSubmitting && !isPolling">Starting...</span>
    <span *ngIf="isPolling">Generating {{ generationProgress }}%</span>
    <mat-spinner *ngIf="isSubmitting" diameter="18" class="d-inline-block ms-2"></mat-spinner>
  </button>
</mat-dialog-actions>
